import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    company: {}
  },
  mutations: {
    setUser(state, param) {
      state.user = {
        id: param.user.ID,
        email: param.user.email,
        display_name: param.user.display_name,
        contact: param.user.contact
      };
    },
    setCompany(state, param) {
      state.company = {
        name: param.company.name
      };
    }
  },
  actions: {}
});
